import { z } from "zod";

export function blankableUrl(message: string) {
  return z
    .string()
    .trim()
    .refine((v) => v === "" || /^https?:\/\/.+/.test(v), { message });
}
